import React from 'react';
import { BookOpen } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-[#0D0D1A] pt-2 pb-20 md:pt-3 md:pb-5 px-4 text-center border-t border-white/5" data-id="element-183" data-mp="3399krv2gfiu6">
      <div className="max-w-4xl mx-auto space-y-1.5" data-id="element-184" data-mp="3h9anlg2a50ca">
        {/* Small logo */}
        <div className="flex items-center justify-center gap-1.5 mb-1.5" data-id="element-185" data-mp="3c9o7myv2h5zs">
          <span className="font-display font-black text-base tracking-tight text-white" data-id="element-186" data-mp="3c7l91qfum4jg">
            PRODI
          </span>
          <span className="font-display font-black text-base tracking-tight text-gold" data-id="element-187" data-mp="2kii7wjj9dab1">
            KIT
          </span>
          <div className="w-5 h-5 rounded-md bg-gradient-to-br from-gold to-orange flex items-center justify-center" data-id="element-188" data-mp="2yag45trvfbps">
            <BookOpen className="w-3 h-3 text-white" strokeWidth={2.5} data-id="element-189" data-mp="2ti55eu8v9vyt" />
          </div>
        </div>

        <p className="text-[#888888] text-[10px] md:text-xs leading-snug" data-id="element-190" data-mp="25savoljugnis">
          © MegaPack Vianda Resuelta — Prodikit — Todos los derechos reservados
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-0.5 text-[#888888] text-[10px] md:text-xs" data-id="element-191" data-mp="1gh83dftxtbht">
          <a href="https://www.prodikit.com" className="hover:text-gold transition-colors" data-id="element-192" data-mp="1lerj6k6a9wbv">
            www.prodikit.com
          </a>
          <span className="text-white/20" data-id="element-193" data-mp="1v5clahl61izj">|</span>
          <a href="mailto:soporteprodikit@gmail.com" className="hover:text-gold transition-colors" data-id="element-194" data-mp="1v4t4x5b5z2nm">
            soporteprodikit@gmail.com
          </a>
          <span className="text-white/20" data-id="element-195" data-mp="12hqc8tt65m5a">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-196" data-mp="17g1mh5ndlyo1">
            @prodikitshop
          </a>
        </div>

        <p className="text-[#666666] text-[9px] md:text-[11px] italic max-w-md mx-auto leading-snug" data-id="element-197" data-mp="1bhvgww6za6fr">
          Precios en USD. Cobro en la moneda local de tu país.
        </p>
      </div>
    </footer>;
}